import React from 'react';
import { SpinnerSvg } from '@nextiva/next-ui';
import "./GeneralSpinner.css";

var GeneralSpinner = function GeneralSpinner() {
  return React.createElement(SpinnerSvg, {
    size: 128,
    thickness: 11
  });
};

export default GeneralSpinner;